/* eslint-disable react/forbid-prop-types,import/prefer-default-export,import/no-unresolved */
import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { isIOS } from 'react-device-detect';
import { SelectCountryDropdown } from 'assets/components';
import { OnboardingBodyLayout } from '../partials';
import Input from '../../../../components/Input';

export const AddPhoneNumberComponent = ({
  form,
  handleSubmitForm,
  handleFormBlur,
  clearFormError,
  renderButtons,
  handleChange,
  selectDropDownFields,
}) => {
  const { t: translate } = useTranslation();

  return (
    <OnboardingBodyLayout
      title={translate('phone_number_title_label')}
      renderButtons={renderButtons}>
      <form onSubmit={handleSubmitForm} id="phone-number-form">
        <div className="d-flex flex-row align-items-end position-relative">
          <div className="form-group onboarding-phone-number-form mb-0 mt-4">
            <SelectCountryDropdown
              name="country_code"
              getOptionLabel={(option) => `+${option.callingCode}`}
              isOptionSelected={(option) =>
                option.callingCode === form.country_code &&
                form.country_code_alpha2 === option.iso3166alpha2
              }
              value={form.country_code}
              flagValue={form.country_code_alpha2}
              onChange={(data, name) => handleChange(data, name)}
              handleBlur={handleFormBlur}
              clearError={clearFormError}
              className="phone-country-code"
              optionName="callingCode"
              prefix="+"
              fieldsInfo={selectDropDownFields}
              containerClass="w-100 position-absolute bg-light p-3 mt-2 rounded shadow-lg"
              dropDownParentClass="py-1"
              withValueImageFlag
              isPhoneNumber
              placeholder={translate('country_label')}
            />
          </div>
          <div className="ps-3 w-100">
            <Input
              groupClassName={`mb-0 mt-4 ${isIOS ? 'ios' : ''}`}
              className={`${isIOS ? 'ios' : ''}`}
              value={form.phone_number}
              name="phone_number"
              type="tel"
              onChange={handleChange}
              onBlur={handleFormBlur}
              onFocus={clearFormError}
              placeholder={translate('phone_number_input_label')}
              label={translate('phone_number_input_label')}
              errorLabel={translate('input_required_error_label')}
              withFloatingLabel
              withErrorLabel
              required
            />
          </div>
        </div>
      </form>
    </OnboardingBodyLayout>
  );
};

AddPhoneNumberComponent.propTypes = {
  form: PropTypes.object.isRequired,
  handleSubmitForm: PropTypes.func.isRequired,
  handleFormBlur: PropTypes.func.isRequired,
  clearFormError: PropTypes.func.isRequired,
  renderButtons: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired,
  selectDropDownFields: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.object])).isRequired,
};
